/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IConfigurationModel } from "@nf/common";

import AppFooterDesktop from "components/AppFooter/AppFooterDesktop";

import styles from "./LandingPageLayout.module.scss";

export interface LandingPageLayoutProps {
  children: React.ReactNode;
  config: IConfigurationModel;
}

const LandingPageLayout = ({ children, config }: LandingPageLayoutProps) => {
  return (
    <div className={styles.container}>
      <section>{children}</section>

      <AppFooterDesktop configuration={config} />
    </div>
  );
};

export default LandingPageLayout;
